import { BasicClient } from '@/utils/httpClient'
export default class Company {
  client
  constructor() {
    this.client = new BasicClient()
  }

  passwordPolicies() {
    return this.client.exec('/v2/user-mod/passwordpolicy', 'GET')
  }

  passwordPoliciesTk(token) {
    return this.client.exec('/v2/user-mod/passwordpolicy/'+token, 'GET')
  }

  getSectors() {
    return this.client.exec('/v2/admin-mod/sectors', 'GET')
  }

  getLocations() {
    return this.client.exec('/v2/admin-mod/locations', 'GET')
  }

  getSectorAndLocation() {
    return this.client.exec('/v2/admin-mod/user/sectorsAndLocations', 'GET')
  }

  getDissatisfiedSignatureMessage() {
    return this.client.exec('/v2/companies/dissatisfiedMessage', 'GET')
  }

  getCertificatesAvailables() {
    return this.client.exec('/v2/selfservice/certificate', 'GET')
  }
}
